/**
 * Blog index page for unfrozen blog post.
 */
import React from 'react';
import { NextPage } from 'next';
import { reduxWrapper } from 'store';

import {
  fetchBlogCategories,
  fetchBlogPosts,
  fetchFeaturedBlogPosts,
} from 'state/actions/blogActions';
import { CacheControlHeaders } from 'constants/Global';

import { BlogPost as IBlogPost, IBlogCategoryPage } from 'types';
import BlogHomePageView from 'views/BlogHomePageView';

interface Props {
  blogCategories: IBlogCategoryPage[];
  featuredBlogPosts: IBlogPost[];
  recentBlogPosts: IBlogPost[];
}

const BlogPost: NextPage<Props> = (props: Props) => (
  <BlogHomePageView {...props} />
);

export const getServerSideProps = reduxWrapper.getServerSideProps(
  async ({ store, res }) => {
    res.setHeader('Cache-Control', CacheControlHeaders.NO_CACHE);

    const fetchBlogCategoriesAction = fetchBlogCategories({
      filterByFrozen: false,
    });
    store.dispatch(fetchBlogCategoriesAction);
    const blogCategories = await fetchBlogCategoriesAction.payload;

    const fetchFeaturedBlogPostsAction = fetchFeaturedBlogPosts({
      filterByFrozen: false,
    });
    store.dispatch(fetchBlogCategoriesAction);
    const featuredBlogPosts = await fetchFeaturedBlogPostsAction.payload;

    const fetchRecentBlogPostsAction = fetchBlogPosts({
      count: 3,
      filterByFrozen: false,
    });
    store.dispatch(fetchRecentBlogPostsAction);
    const recentBlogPosts = await fetchRecentBlogPostsAction.payload;
    return {
      props: {
        blogCategories,
        featuredBlogPosts,
        recentBlogPosts,
      },
    };
  },
);

export default reduxWrapper.withRedux(BlogPost);
